import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import weatherReducer from './features/weather/weatherSlice';
import notificationReducer from './features/notifications/notificationSlice';
import cctvReducer from './features/cctv/cctvSlice';
import utilityMeterReducer from './features/utilityMeters/utilityMeterSlice';
import securityReducer from './features/security/securitySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    weather: weatherReducer,
    notifications: notificationReducer,
    cctv: cctvReducer,
    utilityMeters: utilityMeterReducer,
    security: securityReducer
  },
});

export default store; 